if (
    process.env.YANDEX_SMART_CAPTCHA_TEST_MODE !== 'true' &&
    process.env.YANDEX_SMART_CAPTCHA_TEST_MODE !== 'false'
) {
    throw new Error(`YANDEX_SMART_CAPTCHA_TEST_MODE must be 'true' or 'false'`);
}

export const YANDEX_SMART_CAPTCHA_TEST_MODE =
    (process.env.YANDEX_SMART_CAPTCHA_TEST_MODE as 'true' | 'false') === 'true';

export const APP_URL = process.env.APP_URL;
export const CONFETTI = process.env.CONFETTI === 'true';
export const IS_DEV = (process.env.HIDE_PAGE_FROM_ROBOTS as 'true' | 'false') === 'true';
